import { createTheme, Textarea } from "@mantine/core";

export const skoTheme = createTheme({
  primaryColor: "skoRed",
  colors: {
    skoRed: [
      "#ffeae9",
      "#ffd6d1",
      "#f7aba4",
      "#f17e73",
      "#eb584a",
      "#e83f2f",
      "#e83221",
      "#cd2315",
      "#b81c10",
      "#a1100a"
    ]
  },
  components: {
    Textarea: Textarea.extend({
      defaultProps: {
        resize: "vertical",
      },
    })
  }
});
